export const membershipsFAQ = [
  {
    id: 1,
    label: "Kas įskaičiuojama į Telomera Narystes?",
    description:
      "Telomera narystės apima reguliarius sveikatos tyrimus, individualius mitybos ir sporto planus, tiesiogines konsultacijas su gydytojais ir nuolatinio sveikatos palaikymo paslaugas pagal pasirinktą programą.",
  },
  {
    id: 2,
    label: "Kuo skiriasi CORE nuo APEX narystės?",
    description:
      "CORE narystė orientuota į pagrindinių sveikatos rizikų valdymą ir bazinį asmeninės sveikatos formavimą. APEX yra platesnė narystė, apimanti genomo tyrimus, kompleksines, detalesnes rizikų analizes, farmakogenetiką, CGS stebėjimą bei neribotus susitikimus su asmeniniu gydytoju visų metų eigoje.",
  },
  {
    id: 3,
    label: "Ar pritaikysite planą esant lėtinėms ligoms?",
    description:
      "Taip. Kiekvienai programai priskiriama pirminė konsultacija, po kurios sudaromas tikslus personalizuotas planas. Ypač APEX narystės atveju glaudžiai dirbame su paveldėtomis ir lėtinėmis ligomis.",
  },
  {
    id: 4,
    label: "Ar tyrimų rezultatus galėsiu matyti asmeniškai?",
    description:
      "Taip, visi jūsų sveikatos duomenys ir rodikliai yra pateikiami privačioje LifeTelos platformos naudotojo paskyroje.",
  },
  {
    id: 5,
    label: "Kaip apmokama narystė?",
    description:
      "Galima mokėti vienkartiniu metiniu mokesčiu arba pasiskirstyti per kelių mėnesių įmokas bendradarbiaujant su mūsų partneriais.",
  },
];

export interface FAQItem {
  id: number;
  label: string;
  description: string;
}

export interface FAQGroup {
  number: string;
  label: string;
  items: FAQItem[];
}

export const membershipsFAQGroups: FAQGroup[] = [
  {
    number: "01",
    label: "Narystės ir paketai",
    items: [
      {
        id: 1,
        label: "Kas įskaičiuojama į Telomera Narystes?",
        description:
          "Telomera narystės apima reguliarius sveikatos tyrimus, individualius mitybos ir sporto planus, tiesiogines konsultacijas su gydytojais ir nuolatinio sveikatos palaikymo paslaugas pagal pasirinktą programą.",
      },
      {
        id: 2,
        label: "Kuo skiriasi CORE nuo APEX narystės?",
        description:
          "CORE narystė orientuota į pagrindinių sveikatos rizikų valdymą ir bazinį asmeninės sveikatos formavimą. APEX yra platesnė narystė, apimanti genomo tyrimus, kompleksines, detalesnes rizikų analizes, farmakogenetiką, CGS stebėjimą bei neribotus susitikimus su asmeniniu gydytoju visų metų eigoje.",
      },
      {
        id: 3,
        label: "Ar pritaikysite planą esant lėtinėms ligoms?",
        description:
          "Taip. Kiekvienai programai priskiriama pirminė konsultacija, po kurios sudaromas tikslus personalizuotas planas. Ypač APEX narystės atveju glaudžiai dirbame su paveldėtomis ir lėtinėmis ligomis.",
      },
    ],
  },
  {
    number: "02",
    label: "Tyrimai ir rezultatai",
    items: [
      {
        id: 4,
        label: "Ar galima atlikti tik pilną ištyrimo paketą?",
        description:
          "Pilnas ištyrimo paketas rekomenduojamas, bet nėra būtinas. Galima atlikti paslaugas atskirai, pagal jūsų poreikį, tačiau yra keletas išlygų. Norint atlikti pirmąjį kartą epigenetinį tyrimą, pirmiausia būtina atlikti genetinį tyrimą.",
      },
      {
        id: 5,
        label: "Ar tyrimų rezultatus galėsiu matyti asmeniškai?",
        description:
          "Taip, visi jūsų sveikatos duomenys ir rodikliai yra pateikiami privačioje LifeTelos platformos naudotojo paskyroje.",
      },
      {
        id: 6,
        label: "Nuo kokio amžiaus galima atlikti tyrimus?",
        description:
          "Genetinį tyrimą galima atlikti nuo jauniausio amžiaus, nes šie rodikliai nesikeičia visą gyvenimą. Kiti tyrimai rekomenduojami individualiai aptarus situaciją su pacientu / tėvais.",
      },
    ],
  },
  {
    number: "03",
    label: "Paslaugos ir logistika",
    items: [
      {
        id: 7,
        label: "Kokiuose miestuose teikiamos paslaugos?",
        description:
          "Mėginius galima priduoti Vilniuje, Kaune, Šiauliuose, Panevėžyje bei Mažeikiuose. Gydytojo konsultacijos gyvai vyksta Vilniuje, bet visuomet galime susitarti konsultaciją nuotoliniu būdu.",
      },
      {
        id: 8,
        label: "Ar galima įsigyti dovanų kuponą?",
        description:
          "Dovanų kuponą galima įsigyti visoms paslaugoms, daliai paslaugų ar pinigų sumai. Norint įsigyti kuponą, susisiekite su mumis info@telomera.lt arba +37063988229.",
      },
    ],
  },
  {
    number: "04",
    label: "Apmokėjimas ir tęstinumas",
    items: [
      {
        id: 9,
        label: "Kaip apmokama narystė?",
        description:
          "Galima mokėti vienkartiniu metiniu mokesčiu arba pasiskirstyti per kelių mėnesių įmokas bendradarbiaujant su mūsų partneriais.",
      },
      {
        id: 10,
        label: "Kaip žinoti, kada tyrimus kartoti ar atlikti papildomai?",
        description:
          "Telomera pacientų vadybininkė informuoja pacientus apie kiekvieną žingsnį, padeda nepasimesti tarp konsultacijų išvadų bei susisiekia esant poreikiui kartoti / atlikti papildomus tyrimus.",
      },
    ],
  },
];

export const homeFAQGroups: FAQGroup[] = [
  {
    number: "01",
    label: "Telomera požiūris",
    items: [
      {
        id: 1,
        label: "Kaip Telomera gali man padėti?",
        description:
          "Telomera gali padėti jums anksčiau suprasti, kas vyksta jūsų organizme, kokios yra svarbiausios sveikatos rizikos ir kokie veiksmai turėtų turėti didžiausią poveikį jūsų savijautai, energijai ir ilgalaikei sveikatai.\n\nSkirtingai nei įprastas profilaktinis pasitikrinimas, Telomera neapsiriboja vien tuo, ar rodikliai šiandien patenka į normos ribas. Ji padeda giliau įvertinti metabolinę sveikatą, širdies ir kraujagyslių riziką, uždegiminius procesus, hormonų pusiausvyrą, miego kokybę, streso poveikį, maistinių medžiagų pasisavinimą, genetines predispozicijas ir, priklausomai nuo pasirinktos programos, fizinį pajėgumą bei išplėstinę klinikinę genetiką.\n\nSvarbiausia, kad Telomera padeda ne tik surinkti duomenis, bet ir paversti juos aiškiu planu. Po įvertinimo gaunate specialistų interpretaciją, 12 savaičių gyvensenos korekcijos programą, o programos pabaigoje – pakartotinį vertinimą, kad būtų galima objektyviai matyti progresą.",
      },
      {
        id: 2,
        label: "Kuo Telomera išsiskiria iš kitų panašių klinikų?",
        description:
          "Telomera išsiskiria tuo, kad siūlo ne tik tyrimus, bet ir aiškų, personalizuotą veiksmų planą. Mes apjungiame kraujo tyrimus, genetiką, gyvensenos vertinimą ir, priklausomai nuo programos, pažangesnius metabolinius bei fizinės būklės matavimus į vieną bendrą sveikatos vaizdą.\n\nSvarbiausia, kad Telomera nesibaigia ties rezultatais – po ištyrimo klientas gauna specialistų interpretaciją, 12 savaičių programą ir pakartotinį įvertinimą, kad būtų galima stebėti realų progresą.",
      },
      {
        id: 3,
        label: "Ar Telomera atlieka tik tyrimus?",
        description:
          "Ne. Tyrimai yra tik pradžia. Telomera tikslas – ne tiesiog parodyti daug duomenų, o paversti juos aiškiu veiksmų planu.\n\nPo įvertinimo žmogus gauna specialistų interpretaciją, konsultacijas ir 12 savaičių gyvensenos korekcijos programą. Tai reiškia, kad po tyrimų seka konkretūs žingsniai: ką keisti mityboje, miego režime, fiziniame aktyvume, streso valdyme, papildų vartojime ir ką stebėti toliau.",
      },
      {
        id: 4,
        label: "Kuo Telomera skiriasi nuo įprasto profilaktinio pasitikrinimo?",
        description:
          "Įprastas profilaktinis pasitikrinimas dažniausiai parodo, ar šiuo metu yra aiškių nukrypimų. Telomera vertina plačiau: gliukozės kontrolę, riebalų apykaitą, širdies ir kraujagyslių riziką, uždegiminį foną, hormonų pusiausvyrą, miego kokybę, streso atsaką, maistinių medžiagų pasisavinimą, elgesio bei priklausomybių polinkius.\n\nTai leidžia ne tik pastebėti problemą, bet ir geriau suprasti jos priežastis bei prioritetus. Kai kuriais atvejais matome ne vien tai, kas vyksta dabar, bet ir tai, kur link sveikata juda, jei niekas nebus keičiama.",
      },
    ],
  },
  {
    number: "02",
    label: "Telomera narystės",
    items: [
      {
        id: 5,
        label: "Ką realiai gaunu pasirinkęs Telomera CORE?",
        description:
          "Telomera CORE skirtas žmogui, kuris nori išsamaus prevencinio įvertinimo ir aiškaus veiksmų plano, bet jam dar nereikia giliausio klinikinės genetikos lygio.\n\nCORE apima pagrindines prevencinės sveikatos sritis: kardiometabolinę sistemą, nervų ir kognityvinę būklę, detoksikaciją ir kepenų veiklą, imuninį foną, hormonus, maistinių medžiagų pasisavinimą, elgesio ir priklausomybių polinkius. Taip pat įtrauktos specialistų konsultacijos, 12 savaičių gyvensenos korekcijos programa, pacientų vadyba ir pakartotiniai pagrindinių kraujo rodiklių tyrimai po programos.",
      },
      {
        id: 6,
        label: "Ką papildomai gaunu pasirinkęs Telomera APEX?",
        description:
          "Pasirinkę Telomera APEX, gaunate viską, kas įtraukta į CORE programą, tačiau dar platesnį ir gilesnį ištyrimą bei aukštesnio lygio personalizaciją.\n\nŠi programa papildomai apima nuolatinį gliukozės stebėjimą, VO₂max vertinimą, kūno sudėties analizę, jėgos matavimą ir individualizuotas fizinio aktyvumo rekomendacijas.\n\nTaip pat, įtraukiama farmakogenetika, gydytojo genetiko konsultacija ir klinikinis genomo tyrimas, leidžiantis detaliau įvertinti paveldimas rizikas, retų ligų tikimybę bei šeimos planavimo aspektus. Be to, APEX programoje numatyta asmeninė pacientų vadyba ir pakartotiniai funkciniai matavimai programos pabaigoje, kad būtų galima objektyviai įvertinti pasiektą progresą.",
      },
      {
        id: 7,
        label: "Kodėl kai kuriems žmonėms verta rinktis APEX, o ne CORE?",
        description:
          "APEX verta rinktis tiems, kurie nori ne tik bendro prevencinio vertinimo, bet ir gilesnio atsakymo į klausimą „kaip tiksliai veikia mano organizmas?“\n\nŠis planas labiau tinka žmonėms, kuriems aktualus našumas, sportinė forma, metabolinė kontrolė, detalesnis genetinių rizikų įvertinimas, jautrumas vaistams, platesnis ilgalaikis sekimas ar šeimos planavimo klausimai. Jei žmogus nori daugiau nei bazinio prevencinio plano ir siekia aukščiausio individualizavimo lygio, APEX duoda ženkliai daugiau praktinės informacijos.",
      },
      {
        id: 8,
        label: "Kokie atsiskaitymo būdai galimi perkant narystę?",
        description:
          "Perkant narystę, galima atsiskaityti iš karto arba mokėjimą padalinti į dvi ar tris dalis. Taip pat, galima pasinaudoti Inbank finansavimu be pabrangimo. Svarbu žinoti ir tai, kad pavienės paslaugos tam tikrais atvejais gali būti apmokamos per darbo draudimą, priklausomai nuo jūsų draudimo sąlygų.",
      },
    ],
  },
  {
    number: "03",
    label: "Ar Telomera Jums?",
    items: [
      {
        id: 9,
        label: "Ar po tyrimų gausiu tik rekomendacijų sąrašą?",
        description:
          "Ne. Telomera modelis nėra „atsiųsime rezultatus ir tuo viskas baigsis“. Mūsų požiūris sukurtas taip, kad žmogus turėtų ne tik atsakymus, bet ir lydėjimą pokyčio procese.\n\nTodėl po tyrimų vyksta konsultacijos su specialistais, sudaroma 12 savaičių korekcijos programa, o po jos atliekamas pakartotinis vertinimas. Tai leidžia matyti ne teoriją, o realų pokytį: kas pagerėjo, kas dar stringa ir ką koreguoti toliau.",
      },
      {
        id: 10,
        label:
          "Ar Telomera tinka tik žmonėms, kurie jau turi sveikatos problemų?",
        description:
          "Ne. Telomera labai tinka ir tiems, kurie šiandien jaučiasi pakankamai gerai, bet nori suprasti savo rizikas anksčiau ir veikti prevenciškai.\n\nTai ypač aktualu žmonėms, kurie nori daugiau aiškumo dėl energijos, miego, streso, svorio, sportinio pajėgumo, metabolinės sveikatos ar ilgalaikių paveldimų rizikų. Kitaip tariant, Telomera tinka ne tik tada, kai „kažkas jau blogai“, bet ir tada, kai norisi tikslaus plano, kaip ilgiau išlikti geros būklės.",
      },
    ],
  },
  {
    number: "04",
    label: "Lėtinis nuovargis",
    items: [
      {
        id: 11,
        label: "Kodėl mano kraujo tyrimai normoje, bet jaučiuosi pavargęs?",
        description:
          "„Norma“ dažnai reiškia, kad nėra akivaizdaus trūkumo ar ligos, bet tai dar nereiškia, kad organizmas veikia optimaliai. Nuovargį dažniausiai sukuria keli veiksniai kartu: prastesnis miego atsistatymas, streso apkrova, gliukozės svyravimai, mikroelementų disbalansas ar hormoninis disbalansas. Kai šiuos duomenis sujungiame į vieną vaizdą, tampa aišku, kur yra pagrindinis energijos nutekėjimas ir nuo ko pradėti.",
      },
      {
        id: 12,
        label: "Ar galima būti pavargusiam net miegant 7–8 val.?",
        description:
          "Taip. Trukmė nėra lygu kokybei. Galite miegoti pakankamai, bet turėti daug prabudimų, prastą miego struktūrą ar silpną atsistatymą. Čia labai svarbus ir ritmas: chronotipas pagal DNR padeda suprasti, kada jums optimaliausia eiti miegoti ir kiek valandų miego realiai reikia.",
      },
      {
        id: 13,
        label: "Kada nuovargis labiau susijęs su stresu?",
        description:
          "Kai energija krenta bangomis, sunku atsipalaiduoti, jaučiate nuolatinę vidinę įtampą, atsiranda dirglumas ar nerimas, o net po poilsio neatsigaunate. Tokiu atveju svarbiausia ne bandyti nusiraminti, o sutvarkyti atsistatymo pagrindus: miego ritmą, fizinio krūvio balansą, kofeino laiką, vakaro rutiną ir stebėti, ar atsistatymo rodikliai iš tiesų gerėja.",
      },
      {
        id: 14,
        label: "Kada verta įtarti mikroelementų trūkumą?",
        description:
          "Kai nuovargis labiau kūniškas: jaučiate silpnumą, krenta ištvermė, lėčiau atsigaunate, sunkiau susikaupti, dažniau kimba infekcijos. Tokiu atveju verta ne spėlioti, o tiksliai nustatyti trūkumus.",
      },
      {
        id: 15,
        label: "Kada įtarti skydliaukės problemą?",
        description:
          "Kai nuovargį lydi šalčio netoleravimas, odos sausumas, svorio pokyčiai, širdies ritmo pokyčiai, užkimimas ar kaklo spaudimas, vidurių užkietėjimas, arba yra šeiminė istorija. Jei tokie simptomai kaupiasi, verta įvertinti skydliaukės funkciją atlikus tyrimus.",
      },
      {
        id: 16,
        label: "Ar nuovargis gali būti susijęs su uždegimu?",
        description:
          "Taip. Lėtinis uždegimo fonas dažnai pasireiškia smegenų rūku, mažesne ištverme, lėtesniu atsistatymu, prastesniu miegu ir bendru kūno sunkumu. Tokiais atvejais verta atlikti tyrimus, kad būtų aišku, ar uždegimas padidėjęs, ir jį mažinti kryptingais gyvensenos pokyčiais.",
      },
      {
        id: 17,
        label: "Per kiek laiko realu pajausti teigiamą energijos pokytį?",
        description:
          "Dažniausiai pirmą teigiamą pokytį pajusite per 2–4 savaites, kai sutvarkomi pagrindiniai dalykai, labiausiai atimantys energiją: miegas, dienos ritmas, stresas ir mitybos struktūra. O kad energija taptų stabilesnė ir labiau prognozuojama, paprastai prireikia 8–12 savaičių — per tiek laiko įpročiai įsitvirtina, o rezultatas aiškiai matosi ir pagal savijautą, ir pagal rodiklių dinamiką.",
      },
    ],
  },
  {
    number: "05",
    label: "Raumenų jėga",
    items: [
      {
        id: 18,
        label: "Kodėl raumenų jėga svarbi, jei man 30–40?",
        description:
          "Jėga nėra tik sportas ar estetika. Tai vienas stipriausių rodiklių, parodančių, kaip gerai senstant išlaikysite kūno funkciją, savarankiškumą ir mažesnę sveikatos problemų riziką. Nuo 30–40 metų jėga natūraliai pradeda mažėti kasmet, o jei jos specialiai nestiprinate, dažnai kartu prastėja kūno sudėtis, atsistatymas ir energijos stabilumas.",
      },
      {
        id: 19,
        label: "Ar jėga svarbesnė už svorį?",
        description:
          "Dažniausiai taip. Svoris pasako tik kilogramus, o jėga parodo, kaip kūnas iš tikrųjų funkcionuoja. Du žmonės gali sverti tiek pat, bet vienas gali būti stipresnis, turėti daugiau raumenų ir geresnę laikyseną, o kitas – mažiau raumenų ir silpnesnį stabilumą. Todėl sveikatai ir ilgalaikiam rezultatui svarbiau, ką kūnas gali, nei ką rodo svarstyklės.",
      },
      {
        id: 20,
        label: "Kaip dažnai reikia treniruotis, kad būtų pokytis?",
        description:
          "Kad pokytis būtų matomas, dažniausiai pakanka 2–3 jėgos treniruočių per savaitę. Svarbiausia nuoseklumas ir progresas: palaipsniui didinti pasipriešinimą, gerinti techniką ir duoti kūnui laiko atsistatyti. Viena gera savaitė nieko nereiškia, bet 8–12 savaičių nuoseklumo paprastai duoda realų, apčiuopiamą rezultatą.",
      },
      {
        id: 21,
        label: "Ar jėga susijusi su metaboline sveikata?",
        description:
          "Taip. Daugiau raumenų ir didesnė jėga paprastai reiškia geresnę gliukozės kontrolę, jautrumą insulinui ir stabilesnę energiją. Dėl to jėgos treniruotės dažnai padeda ir kūno sudėčiai, ir bendrai savijautai, net jei tikslas nėra sportiniai rezultatai.",
      },
      {
        id: 22,
        label: "Kada verta kartoti jėgos matavimą?",
        description:
          "Kad matytumėte realų progresą ir laiku pakoreguotumėte planą, jėgos matavimą verta kartoti reguliariai. Telomeros programoje jį kartojame kas 6 mėnesius — tai pakankamas intervalas, kad pokytis būtų aiškiai matomas ir palyginamas, o rekomendacijas būtų galima atnaujinti pagal naują rezultatą.",
      },
    ],
  },
  {
    number: "06",
    label: "Ištvermės rezervas (VO₂max)",
    items: [
      {
        id: 23,
        label: "Kas yra VO₂max ir kodėl jis svarbus sveikatai?",
        description:
          "VO₂max parodo, kiek efektyviai jūsų kūnas gali panaudoti deguonį fizinio krūvio metu. Paprastai tariant, tai vienas tiksliausių rodiklių, kuris apibūdina širdies–plaučių ir raumenų darbo pajėgumą. Aukštesnis VO₂max dažniausiai reiškia geresnę ištvermę, lengvesnį atsistatymą ir mažesnę širdies-kraujagyslių riziką.",
      },
      {
        id: 24,
        label: "Ar VO₂max svarbus, jei nesiekiu sportinių rezultatų?",
        description:
          "Taip. VO₂max svarbus ir tada, kai nesiekiate sportinių rezultatų, nes jis parodo jūsų kardiorespiracinį pajėgumą – kaip efektyviai kūnas tvarkosi su krūviu, atsistato ir kiek tvirtai veikia širdies–plaučių sistema. Gerindami VO₂max jūs mažinate ligų rizikas: didelėje 122 007 žmonių studijoje aukštesnis kardiorespiracinis pajėgumas buvo aiškiai susijęs su mažesne mirtingumo rizika.",
      },
      {
        id: 25,
        label: "Kaip greitai galima pagerinti VO₂max?",
        description:
          "Dažniausiai pirmi pokyčiai matosi per 4–8 savaites, jei treniruotės yra reguliarios ir paremtos tinkamu intensyvumu. Ryškesnis ir stabilesnis progresas paprastai ateina per 8–12 savaičių, ypač jei kartu sutvarkomas miegas ir atsistatymas.",
      },
      {
        id: 26,
        label: "Ar VO₂max susijęs su ilgaamžiškumu?",
        description:
          "Taip. Aukštesnis kardiorespiracinis pajėgumas yra vienas patikimiausių rodiklių, siejamų su mažesne ligų rizika ir geresne sveikatos prognoze. Tai patvirtina ir didelės apimties klinikinės studijos.",
      },
      {
        id: 27,
        label: "Kada verta kartoti VO₂max testą?",
        description:
          "Kad matytumėte, ar planas veikia, testą verta kartoti reguliariai. Praktinis intervalas – kas 6 mėnesius, o jei aktyviai keičiama treniruočių programa ar siekiama greitesnio progreso, galima kartoti ir dažniau (pvz., kas 3 mėnesius).",
      },
    ],
  },
  {
    number: "07",
    label: "Autoimuninės ligos",
    items: [
      {
        id: 28,
        label:
          "Kodėl autoimuninės ligos simptomai tai sustiprėja, tai atslūgsta?",
        description:
          "Autoimuninės būklės dažnai vyksta ciklais: imuninė sistema tampa aktyvesnė, simptomai paaštrėja, vėliau nuslūgsta. Reikšmingi keli dalykai vienu metu – miego kokybė, streso lygis, infekcijos, krūvio perteklius, mitybos netoleravimai, hormoniniai svyravimai ar mikroelementų trūkumai. Dažniausiai paūmėjimą sukelia ne vienas faktorius, o jų kombinacija.",
      },
      {
        id: 29,
        label: "Ar stresas gali realiai provokuoti simptomus?",
        description:
          "Taip. Ilgalaikis stresas silpnina atsistatymą ir gali didinti uždegiminį foną, todėl simptomai dažniau paaštrėja arba užsitęsia.",
      },
      {
        id: 30,
        label: "Kaip suderinti sporto krūvį, kad nepabloginti simptomų?",
        description:
          "Svarbiausia rasti krūvį, po kurio jaučiatės geriau, o ne blogiau. Dažniausiai tinka nuoseklus, vidutinio intensyvumo judėjimas ir jėgos treniruotės, o ne dažnos maksimalaus krūvio treniruotės. Praktinė taisyklė: jei po treniruotės 24–48 val. savijauta prastėja, krūvis per didelis ir jį reikia mažinti arba keisti.",
      },
      {
        id: 31,
        label: "Kokie mikroelementų trūkumai dažniausiai blogina simptomus?",
        description:
          "Dažniausiai autoimuninei savijautai neigiamai atsiliepia geležies (feritino), vitamino D, B12, magnio, cinko, seleno trūkumai. Tačiau svarbiausia ne spėti, o atlikti tyrimus, nes tiek trūkumas, tiek perteklius gali bloginti savijautą.",
      },
      {
        id: 32,
        label: "Kaip suprasti, ar man reikia gilesnės diagnostikos?",
        description:
          "Jei simptomai greitai stiprėja, atsiranda nauji ar neįprasti požymiai, ryškiai krenta svoris, laikosi karščiavimas, atsiranda dusulys, krūtinės skausmas, alpimai, kraujas išmatose, stiprūs neurologiniai simptomai ar labai pakinta laboratoriniai rodikliai. Taip pat, jei savijauta bloga nepaisant kryptingų korekcijų arba paūmėjimai kartojasi dažnai.",
      },
      {
        id: 33,
        label: "Ar miegas turi įtakos paūmėjimams?",
        description:
          "Taip. Prastas miegas mažina atsistatymą ir didina jautrumą stresui bei uždegimui, todėl paūmėjimai dažniau sustiprėja ir sunkiau nuslūgsta. Net kelių naktų prastas miegas gali pakeisti savijautą.",
      },
      {
        id: 34,
        label: "Kiek laiko reikia, kad savijauta stabilizuotųsi?",
        description:
          "Tai priklauso nuo būklės ir to, kiek faktorių vienu metu neigiamai veikia ligos valdymą. Dažnai pirmi teigiami pokyčiai juntami per 2–4 savaites (kai sutvarkomas miegas, krūvis, mitybos struktūra), o stabilesnis rezultatas paprastai ateina per 8–12 savaičių nuoseklaus režimo.",
      },
      {
        id: 35,
        label: "Kaip sekti progresą, jei tyrimai geri, bet jaučiuosi blogai?",
        description:
          "Tokiu atveju svarbu sekti ne tik laboratorinius skaičius, bet ir kasdienius rodiklius: miego kokybę, atsistatymą (pvz., HRV/pulsą), simptomų intensyvumo skalę, energijos stabilumą, treniruočių toleranciją, virškinimo ir odos būklę. Kai šiuos duomenis fiksuojate nuosekliai, tampa aiškiau, kas realiai gerina savijautą, o kas provokuoja paūmėjimus.",
      },
    ],
  },
  {
    number: "08",
    label: "Elgesys ir priklausomybės",
    items: [
      {
        id: 36,
        label: "Ar genetika reiškia, kad nieko nepakeisiu?",
        description:
          "Ne. Genetika nurodo polinkius, o ne galutinį rezultatą. Ji padeda suprasti, kur jums bus sunkiau ir kas veikia geriausiai: kokie įpročiai lengviau įsitvirtina, kokie dirgikliai stipriau veikia, kaip kūnas reaguoja į stresą, miegą ar stimuliatorius. Tai duomenys, kurie leidžia planą pritaikyti jums, o ne dar vieną kartą bandyti universalias taisykles.",
      },
      {
        id: 37,
        label: "Ar čia terapija ar sveikatos programa?",
        description:
          "Tai sveikatos programa, orientuota į praktinius sprendimus: miegą, streso valdymą, kasdienę rutiną, mitybos struktūrą, fizinį aktyvumą ir, kai reikia, saugų papildų bei vaistų suderinimą. Jei matome, kad situacijai reikalinga psichoterapija ar priklausomybių specialistas, tai aiškiai įvardiname ir parengiame tolimesnius žingsnius.",
      },
      {
        id: 38,
        label: "Kodėl valia dingsta vakare?",
        description:
          "Vakare krenta energija ir savikontrolės resursai, ypač jei diena buvo įtempta, trūko miego, valgymas buvo chaotiškas ar daug kofeino. Tuomet smegenys natūraliai renkasi greitą atlygį: nikotiną, cukrų, alkoholį ar socialinę mediją. Problema dažniausiai ne valios trūkumas, o netinkama gyvensena ir rutina.",
      },
      {
        id: 39,
        label: "Kaip miegas ir stresas susiję su paslydimais?",
        description:
          "Prastas miegas didina impulsyvumą ir norą greitam atlygiui. Stresas kelia įtampą, o paslydimas tampa greičiausiu būdu ją numušti. Kai sutvarkomas miego ritmas ir atsistatymas, o stresas valdomas per realius įpročius, paslydimų dažnis paprastai krenta.",
      },
      {
        id: 40,
        label: "Ar reikia mesti viską iš karto?",
        description:
          "Dažniausiai ne. Viskas iš karto dažnai baigiasi tuo pačiu ciklu: stiprus startas ir staigus kritimas. Stabiliau veikia aiškus planas su 1–2 svarbiausiais naujais įpročiais pradžiai. Tikslas yra tvarumas, ne idealumas.",
      },
      {
        id: 41,
        label: "Per kiek laiko atsiranda stabilumas?",
        description:
          "Dažniausiai pirmą palengvėjimą pajusite per 2–4 savaites, kai sutvarkomi pagrindiniai dalykai, labiausiai išprovokuojantys paslydimus: miegas, stresas ir dienos struktūra. O stabilesnis rezultatas paprastai ateina per 8–12 savaičių, kai nauji įpročiai įsitvirtina ir tampa mažiau priklausomi nuo nuotaikos ar dienos eigos.",
      },
      {
        id: 42,
        label: "Ką daryti po paslydimo?",
        description:
          "Svarbiausia paslydimo nepriimti, kaip „visa savaitė sugadinta“. Grįžkite prie plano nuo kito veiksmo. Įsivardinkite, kas konkrečiai jį sukėlė (miego trūkumas, stresas, alkoholis, alkis, konfliktas) ir koreguokite vieną dalyką, kuris kitą kartą sumažins tikimybę. Tikslas – mažinti paslydimų dažnį ir poveikį, o ne siekti nulio nuo pirmos savaitės.",
      },
    ],
  },
  {
    number: "09",
    label: "Vaistų pritaikomumas",
    items: [
      {
        id: 43,
        label: "Kas yra farmakogenetika?",
        description:
          "Farmakogenetika parodo, kaip jūsų organizmas pagal genetiką pasisavina vaistus. Todėl vieni žmonės tą patį vaistą toleruoja gerai, o kitiems jis būna per silpnas, per stiprus arba sukelia šalutinius poveikius.",
      },
      {
        id: 44,
        label: "Kodėl tas pats vaistas vieniems tinka, o kitiems – ne?",
        description:
          "Nes skiriasi žmonių genetika: kaip greitai vaistą suskaido kepenys, kaip jautriai veikia receptoriai ir kaip organizmas reaguoja į tą pačią dozę. Vieniems vaistas organizme išlieka per trumpai, kitiems – per ilgai. Dėl to gali skirtis efektas, toleravimas ir šalutinių reakcijų rizika.",
      },
      {
        id: 45,
        label: "Kaip sužinoti, ar mano organizmas tinkamai pasisavina vaistus?",
        description:
          "Vertiname jūsų genetinius duomenis ir realią reakciją į vaistą. Tai padeda suprasti, ar jūsų organizmas vaistą skaido per greitai ar per lėtai, ir ką verta koreguoti renkantis vaistą ar dozę.",
      },
      {
        id: 46,
        label: "Ką daryti, jei vaistas veikia per silpnai?",
        description:
          "Pirmas žingsnis – ne didinti dozę savarankiškai, o įvertinti priežastį: ar vaistas tinkamai parinktas, ar jis tikrai vartojamas taip, kaip reikia, ar nėra sąveikų su kitais vaistais ar papildais, ar organizmas jo neskaido per greitai. Turint genetinius duomenis lengviau su gydytoju nuspręsti, ar logiškiau koreguoti dozę ar keisti vaistą.",
      },
      {
        id: 47,
        label: "Ar mano vartojami papildai gali keisti vaisto poveikį?",
        description:
          "Taip. Kai kurie papildai gali keisti vaistų skaidymą, stiprinti ar silpninti poveikį, didinti mieguistumą, kraujavimo riziką ar kitus nepageidaujamus efektus. Dėl to svarbu vertinti visą vartojamų preparatų sąrašą kartu.",
      },
      {
        id: 48,
        label: "Ar verta daryti tyrimą, jei vartoju tik vieną vaistą?",
        description:
          "Verta, jei vaistą vartojate reguliariai arba nejaučiate tinkamo efekto. Tyrimas padeda išvengti bandymų ir greičiau rasti tinkamą sprendimą.",
      },
    ],
  },
  {
    number: "10",
    label: "Gyvensenos pokyčiai",
    items: [
      {
        id: 49,
        label: "Ką daryti, jei programos nepavyksta laikytis 100%?",
        description:
          "Svarbiausia laikytis pagrindinių dalykų didžiąją dalį laiko ir greitai grįžti po nukrypimo. Programoje tam ir yra aiškūs minimalūs veiksmai, kurie duoda didžiausią efektą net tada, kai savaitė užimta.",
      },
      {
        id: 50,
        label: "Kaip atrodo gyvensenos prioritetinės sritys?",
        description:
          "Prioritetai yra 1–3 veiksmai, kurie labiausiai keičia savijautą. Pavyzdžiui: stabilus miego ritmas, 2–3 jėgos treniruotės per savaitę, paprasta mitybos struktūra (baltymas + daržovės + normalus valgymo ritmas).",
      },
      {
        id: 51,
        label: "Kaip matuojamas progresas?",
        description:
          "Žiūrime savijautos dinamiką (energija, miegas, stresas, simptomai), objektyvias metrikas (miego rodikliai, aktyvumas, pulsas/atsistatymas) ir pakartotinius tyrimus pagal jūsų tikslą.",
      },
      {
        id: 52,
        label: "Per kiek laiko atsiranda naujas įprotis?",
        description:
          "Dažniausiai po 2–4 savaičių tampa lengviau laikytis naujo gyvensenos plano. Per 8–12 savaičių įpročiai dažniausiai įsitvirtina taip, kad tampa nuoseklūs ir nereikalauja nuolatinės motyvacijos.",
      },
    ],
  },
  {
    number: "11",
    label: "Kūno sudėtis",
    items: [
      {
        id: 53,
        label: "Ką parodo kūno sudėties analizės tyrimas?",
        description:
          "Jis parodo, iš ko susideda jūsų svoris, kiek turite riebalų, kiek liesos masės (raumenų), kaip pasiskirstę riebalai ir kaip tai kinta laike. Tai leidžia matyti realų progresą: ar mažėja riebalai, ar išlaikomi / auginami raumenys, ir ar pokytis vyksta ten, kur svarbiausia sveikatai.",
      },
      {
        id: 54,
        label: "Kas yra visceraliniai riebalai?",
        description:
          "Tai riebalai, esantys giliai pilvo srityje, aplink vidaus organus. Jie labiau susiję su metaboline rizika nei poodiniai riebalai, todėl jų mažėjimas dažnai yra vienas svarbiausių sveikatos tikslų, net jei svoris nekinta daug.",
      },
      {
        id: 55,
        label: "Ar galima mažinti riebalus kartu auginant raumenis?",
        description:
          "Taip, ypač jei esate pradedantysis, grįžtate po pertraukos arba iki šiol neturėjote nuoseklaus jėgos treniruočių plano. Tam reikia trijų dalykų: jėgos treniruočių, pakankamai baltymų ir protingo kalorijų balanso. Dažniausiai tai vyksta lėčiau nei vien tik svorio metimas, bet rezultatas būna geresnis.",
      },
      {
        id: 56,
        label: "Kodėl pilvas auga net nepersivalgant?",
        description:
          "Dažniausios priežastys yra mažėjantis raumenų kiekis ir aktyvumas, prastesnis miegas ir stresas, hormoniniai pokyčiai, didesnis sėdėjimas, skysčių kaupimas, taip pat gliukozės svyravimai ir jautrumas insulinui. Kartais pilvo augimas būna ne tik dėl didelio riebalų kiekio, bet ir dėl pilvo pūtimo ar uždegiminės reakcijos į maistą.",
      },
      {
        id: 57,
        label: "Kaip tai susiję su gliukoze ir lipidais?",
        description:
          "Didesnis visceralinių riebalų kiekis dažnai siejasi su prastesne gliukozės kontrole ir lipidų profilio pablogėjimu. Kitaip tariant, kai pilvo riebalų mažėja, lengviau stabilizuoti energiją, mažinti metabolinę riziką ir pagerinti kraujo rodiklius.",
      },
    ],
  },
  {
    number: "12",
    label: "Mikroelementų ir vitaminų pasisavinamumas",
    items: [
      {
        id: 58,
        label:
          "Kodėl man trūksta vitaminų ar mikroelementų, nors maitinuosi teisingai?",
        description:
          "Nes trūkumai atsiranda ne tik nuo mitybos. Jie gali atsirasti dėl didesnio maisto medžiagų poreikio (stresas, didelis krūvis), dėl netekčių (pvz., gausios mėnesinės, prakaitavimas), dėl virškinimo problemų ar uždegiminio fono. Prie to prisideda ir genetika. Kai kuriems žmonėms tam tikrų vitaminų ar mikroelementų reikia daugiau, arba organizmas juos apdoroja mažiau efektyviai, todėl vien gera mityba ne visada išsprendžia problemą.",
      },
      {
        id: 59,
        label:
          "Per kiek laiko paprastai pagerėja feritinas, vitaminas B12 ir vitaminas D?",
        description:
          "Terminas priklauso nuo pradinio lygio, trūkumo priežasties ir to, kaip organizmas pasisavina medžiagą. Vitamino D rodikliai dažniausiai keičiasi po 6–8 savaičių, stabilesnis rezultatas pasiekiamas per 2–3 mėnesius. B12 neretai pakyla greičiau – per kelias savaites, jei parinkta tinkama papildo forma. Feritinas paprastai atsistato lėčiausiai – dažnai per 2–4 mėnesius ar ilgiau. Genetika gali paaiškinti, kodėl vieniems šie rodikliai atsistato greitai, o kitiems reikia ilgesnio laiko ar kitokios strategijos.",
      },
      {
        id: 60,
        label: "Kokios gali būti papildų įsisavinimo problemos?",
        description:
          "Dažniausiai todėl, kad netinka forma, dozė ar vartojimo laikas, arba trukdo sąveikos su kitais papildais ar vaistais. Labai dažnai įtakos turi virškinimas. Jei yra žarnyno problemų, rodikliai gali neatsistatyti taip, kaip tikimasi. Genetika irgi svarbi, nes ji gali parodyti, kad tam tikros medžiagos jūsų organizme panaudojamos kitaip, todėl reikia labiau pritaikyto pasirinkimo, o ne universalaus papildo.",
      },
      {
        id: 61,
        label: "Kodėl savijauta negerėja net vartojant papildus?",
        description:
          "Dažnai todėl, kad papildai pataiko ne į pagrindinę problemą. Nuovargį gali labiau lemti miegas, stresas, hormonai ar gliukozės svyravimai. Kitas variantas – rodikliai realiai negerėja, nes papildas netinka jums (forma, dozė, laikas) arba yra pasisavinimo kliūčių. Genetika padeda suprasti, kur gali būti silpna grandis, bet sprendimas vis tiek turi būti paremtas tuo, kas realiai keičiasi tyrimuose ir kas keičiasi savijautoje.",
      },
    ],
  },
  {
    number: "13",
    label: "Stresas",
    items: [
      {
        id: 62,
        label: "Ar kortizolis visada turi būti žemas?",
        description:
          "Ne. Kortizolis yra hormonas, reikalingas energijai ir budrumui. Svarbiausia ne žemas kortizolis, o tai, ar jis veikia tinkamu ritmu - aukštesnis ryte, žemesnis vakare. Problemų dažniausiai atsiranda tada, kai organizmas ilgai išlieka įtampoje ir atsistatymas prastėja.",
      },
      {
        id: 63,
        label: "Kodėl poilsis nepadeda?",
        description:
          "Kartais poilsis yra tik sustojimas, bet ne atsistatymas. Jei miegas nekokybiškas, ritmas chaotiškas, per daug kofeino, per didelis krūvis ar nuolatinė įtampa, kūnas ir toliau lieka streso režime net tada, kai nedirbate. Todėl Telomeroje dirbame ne su vienkartiniu poilsiu, o su atsistatymo sistema per 12 savaičių: miegas, ritmas, krūvis, vakaro rutina ir stebėjimas, ar rodikliai gerėja.",
      },
      {
        id: 64,
        label: "Kada kofeinas tampa problema?",
        description:
          "Kofeinas tampa problema, kai jis pradeda gadinti miegą ir atsistatymą, arba kai juo bandote kompensuoti nuovargį. Dažniausi ženklai: sunku užmigti, prabundate naktį, ryte vis tiek jaučiatės pavargę, atsiranda vidinė įtampa ar spartesnis širdies plakimas. Pagal genetiką matome, ar kofeiną skaidote greitai ar lėtai, todėl galime tiksliai parinkti, kada ir kiek jo vartoti, kad jis netrukdytų miegui.",
      },
      {
        id: 65,
        label: "Ar sportas gali didinti stresą?",
        description:
          "Taip, jei krūvis per didelis arba per intensyvus jūsų dabartinei būklei. Tuomet po treniruotės krenta energija, blogėja miegas, atsiranda didesnis dirglumas, sunku atsistatyti. Telomeroje krūvį parenkame taip, kad jis keltų pajėgumą ir gerintų savijautą, o ne užkrautų dar daugiau streso.",
      },
      {
        id: 66,
        label: "Kaip sumažinti vakarinius nerimo epizodus?",
        description:
          "Dažniausiai tai sprendžiama ne vien psichologiškai, o per fiziologiją. Pagrindiniai svertai yra aiškus miego ritmas, kofeino ribojimas, vakaro rutina ir stabilus dienos krūvis. Telomeroje tam sudedame paprastą, įgyvendinamą vakaro planą ir stebime, ar miegas bei atsistatymas realiai gerėja.",
      },
      {
        id: 67,
        label: "Kada verta darytis gilesnius tyrimus?",
        description:
          "Kai stresas ir prasta savijauta užsitęsia, stipriai trukdo kasdienybei, atsiranda naujų simptomų (pvz., ryškūs širdies ritmo sutrikimai, alpimai, stiprus dusulys), arba kai per 8–12 savaičių kryptingą atsistatymo programą nėra aiškaus progreso. Tokiais atvejais logiška ne spėlioti, o pasirinkti tikslesnę diagnostiką ir, jei reikia, nukreipimą pas reikiamą specialistą.",
      },
    ],
  },
  {
    number: "14",
    label: "Paveldimų ligų rizika",
    items: [
      {
        id: 68,
        label: "Ar genetika gali diagnozuoti ligas?",
        description:
          "Genetinis tyrimas parodo polinkius ir rizikas, bet jis pats savaime nediagnozuoja ligos. Diagnozė nustatoma pagal klinikinius tyrimus ir gydytojo vertinimą. Genetika duoda informaciją, ką verta stebėti ir kur prevencija turi didžiausią prasmę.",
      },
      {
        id: 69,
        label: "Kaip suprasti padidėjusią riziką genetiniame tyrime?",
        description:
          "Tai reiškia, kad jūsų tikimybė susidurti su tam tikra liga yra didesnė nei vidutinė. Rizika priklauso ir nuo gyvensenos, ir nuo kitų veiksnių, todėl svarbiausia – paversti rezultatą aiškiu prevencijos planu.",
      },
      {
        id: 70,
        label:
          "Ką daryti, jei genetinis tyrimas rodo didesnę onkologinę riziką?",
        description:
          "Tokiu atveju genetikas paaiškina, ką radinys realiai reiškia, ir sudaro konkretų veiksmų planą. Kokius profilaktinius tyrimus atlikti, kaip dažnai juos kartoti ir pas kokį specialistą kreiptis. Telomeros narystėse tai integruojama į bendrą jūsų sveikatos planą, kad prevencija būtų nuosekli, o ne vienkartinis veiksmas.",
      },
      {
        id: 71,
        label: "Ar užtenka genetinį tyrimą atlikti vieną kartą?",
        description:
          "Dažniausiai taip, nes jūsų DNR nesikeičia. Tačiau laikui bėgant gali keistis mokslo žinios ir interpretacija, todėl svarbi ne tik analizė, bet ir tai, kad ją peržiūri specialistas bei atnaujina rekomendacijas, jei atsiranda naujų reikšmingų duomenų.",
      },
      {
        id: 72,
        label: "Kaip vertinama šeimos istorija?",
        description:
          "Vertiname ne tik tai, ar šeimoje buvo liga, bet ir konkrečius faktus: kuris giminaitis sirgo, kokio amžiaus, kokia tiksliai diagnozė ir ar tokių atvejų šeimoje yra daugiau. Tai leidžia suprasti, ar rizika kartojasi ir sudaryti tikslesnį prevencijos planą.",
      },
      {
        id: 73,
        label: "Kada geriausia darytis genetinius tyrimus?",
        description:
          "Tada, kai norite veikti iš anksto, o ne laukti simptomų. Ypač verta, jei šeimoje buvo ankstyvų onkologinių, širdies-kraujagyslių ar kitų rimtų ligų, arba jei norite ilgalaikės prevencijos strategijos. Kuo anksčiau turite informaciją, tuo daugiau laiko turite prevencijai.",
      },
    ],
  },
  {
    number: "15",
    label: "Aukštas cholesterolis",
    items: [
      {
        id: 74,
        label: "Kas yra ApoB rodiklis?",
        description:
          "ApoB galima suprasti kaip rodiklį, kuris parodo, kiek kraujyje yra dalelių, galinčių kauptis kraujagyslių sienelėse ir didinti aterosklerozės riziką. Dėl to jis dažnai padeda tiksliau įvertinti riziką nei vien tik LDL rodiklis.",
      },
      {
        id: 75,
        label: "Kada aukštas LDL cholesterolis tampa problema?",
        description:
          "LDL cholesterolis tampa problema tada, kai jis ilgą laiką yra per aukštas, ypač jei kartu yra kiti rizikos veiksniai (šeimos istorija, aukštas Lp(a), uždegimo fonas, rūkymas, gliukozės sutrikimai). Vienas skaičius nepasako visko, todėl reikia vertinti visą kontekstą.",
      },
      {
        id: 76,
        label:
          "Ar gyvensenos pokyčių gali pakakti, ar dažnai reikia ir vaistų?",
        description:
          "Kartais gyvensenos pokyčių pakanka, ypač jei pagrindinė priežastis yra mitybos struktūra, mažas aktyvumas, prastas miegas ar stresas. Tačiau jei rizika didesnė dėl genetikos arba rodikliai išlieka aukšti nepaisant pastangų, gali reikėti vaistų. 12 savaičių planas padeda aiškiai pamatyti, kiek galite pakeisti susitvarkę savo gyvenseną.",
      },
      {
        id: 77,
        label: "Per kiek laiko galima pamatyti realų LDL cholesterolio pokytį?",
        description:
          "Pirmi pokyčiai dažnai matosi per 4–6 savaites, jei pokyčiai nuoseklūs. Patikimesnis vaizdas dažniausiai susiformuoja per 8–12 savaičių, todėl šis laikotarpis yra praktiškas realiam progresui įvertinti ir planui patikslinti.",
      },
      {
        id: 78,
        label: "Ką praktiškai reiškia genetinė rizika cholesterolio valdyme?",
        description:
          "Tai reiškia, kad jūsų organizmas turi polinkį į aukštesnius rodiklius ar didesnę aterosklerozės riziką net ir laikantis gana tvarkingos gyvensenos. Tai nėra diagnozė ir nėra garantija, bet tai signalas, kad prevencija turi būti nuoseklesnė, o stebėsena – reguliari.",
      },
      {
        id: 79,
        label: "Kaip derinti su vaistais?",
        description:
          "Svarbiausia turėti vieną aiškų planą, kad nebūtų chaoso ir nereikalingų sąveikų. Gyvensenos pokyčiai paprastai stiprina rezultatą, o papildai turi būti parenkami atsargiai, ypač jei vartojate vaistus. Vaistų keitimo ar dozių sprendimai visada lieka gydytojui, o jūs gaunate aiškų pagrindą, ką stebėti ir ką aptarti.",
      },
    ],
  },
  {
    number: "16",
    label: "Miegas",
    items: [
      {
        id: 80,
        label: "Kodėl prabundu 3–4 val. Ryto?",
        description:
          "Dažniausiai taip nutinka, kai kūnas naktį neatsipalaiduoja iki galo. Tai gali lemti vakarinė įtampa, per vėlai vartotas kofeinas, alkoholis, sunkus ar vėlyvas maistas, per šilta miegamoji aplinka arba nereguliarus ritmas. Tokius prabudimus geriausia spręsti ne spėjimais, o pagal miego duomenis, kad aiškiai matytusi, kas konkrečiai trikdo kokybišką miegą.",
      },
      {
        id: 81,
        label: "Ką HRV sako apie miegą?",
        description:
          "HRV parodo, ar naktį organizmas pereina į atsistatymo režimą. Kai HRV stabilus ir aukštesnis, dažniausiai atsistatymas geresnis. Kai HRV žemas arba labai svyruoja, kūnas dažnai lieka įtampoje, net jei miego valandų užtenka. Todėl HRV yra vienas patikimiausių rodiklių, padedančių įvertinti, ar miego metu atsistatote.",
      },
      {
        id: 82,
        label: "Kiek miego man iš tikrųjų reikia?",
        description:
          "Vieniems užtenka 7 valandų, kitiems reikia 8–9. Telomeroje nustatomas jūsų chronotipas pagal genetiką, o realus poreikis patikslinamas pagal miego metrikas ir savijautą. Ar ryte atsikeliate su energija, kiek yra prabudimų, kaip atrodo HRV ir pulsas naktį. Tikslas – rasti jums tinkamiausią miego trukmę, kuri duoda stabilų atsistatymą.",
      },
      {
        id: 83,
        label:
          "Ką daryti, jei užmiegu gerai, bet ryte jaučiuosi pavargęs (-usi)?",
        description:
          "Tuomet problema dažniausiai yra miego kokybė, o ne užmigimas. Svarbu įvertinti, ar užtenka gilaus ir REM miego ir ar naktį vyksta atsistatymas. Dažniausiai trukdo vakarinė įtampa, vėlyvas maistas, alkoholis, kofeinas, per šilta aplinka arba netinkamas miego laikas pagal jūsų chronotipą. Sutvarkius šiuos dalykus, ryto savijauta paprastai greitai pagerėja.",
      },
      {
        id: 84,
        label: "Per kiek laiko galima pagerinti miego kokybę?",
        description:
          "Pirmas rezultatas dažnai juntami per 1–2 savaites, kai sutvarkomas ritmas ir vakaro įpročiai. Stabilesnis rezultatas dažniausiai ateina per 4–8 savaites, o per 12 savaičių jau galima aiškiai matyti, kas veikia ir ką verta palikti kaip pastovų režimą.",
      },
      {
        id: 85,
        label: "Kaip greičiausiai atstatyti ritmą po kelionių?",
        description:
          "Greičiausiai padeda fiksuotas kėlimosi laikas nuo pirmos dienos, ryto šviesa kuo anksčiau, judėjimas dieną ir mažiau šviesos bei ekranų vakare. Kofeiną geriausia riboti iki pirmos dienos pusės. Jei kelionė buvo per kelias laiko juostas, adaptaciją pagreitina režimo suderinimas pagal jūsų chronotipą.",
      },
    ],
  },
  {
    number: "17",
    label: "Mityba",
    items: [
      {
        id: 86,
        label: "Kaip suprasti, kurie produktai man netinka?",
        description:
          "Dažniausiai tai matosi per pasikartojančią savijautą po valgio, kaip pilvo pūtimą, sunkumą, mieguistumą, energijos kritimą, odos reakcijas ar prastesnį miegą. Telomeroje tai vertiname ne spėjimais, o sujungdami jūsų simptomus su duomenimis iš kraujo tyrimų, genetikos ir gliukozės stebėjimo. Taip aiškiai matosi, kurie produktai jums tinka, o kurie nuolat išbalansuoja savijautą.",
      },
      {
        id: 87,
        label: "Kaip sumažinti alkį ir užkandžiavimą?",
        description:
          "Alkį dažniausiai palaiko trys dalykai: per mažai baltymų ir skaidulų, per ilgos pertraukos tarp valgymų ir dideli energijos svyravimai dienos eigoje. Praktinis sprendimas – aiški valgymų struktūra, pakankamas baltymų kiekis  kiekviename valgyme ir mažiau „tuščių“ kalorijų, kurios greitai sukelia alkį. Jei užkandžiavimą labiausiai kelia stresas ar prastas miegas, tai sprendžiama kartu su režimu, nes vien dietos taisyklės dažnai neveikia.",
      },
      {
        id: 88,
        label: "Ką daryti, jei virškinimas jautrus?",
        description:
          "Pirmiausia verta supaprastinti mitybą ir laikinai sumažinti produktų, kurie dažniausiai dirgina (labai riebus, labai aštrus maistas, alkoholis, daug perdirbtų produktų, dideli porcijų šuoliai). Tada svarbu atsirinkti jūsų asmeninius dirgiklius ir susidėti planą, kuris mažina simptomus, bet išlieka realus kasdienybėje. Jei matome požymių, kad problema gali būti gilesnė, rekomenduojame tikslesnį ištyrimą.",
      },
      {
        id: 89,
        label: "Kaip maitintis, jei daug keliauju ar dirbu intensyviai?",
        description:
          "Tokiu atveju geriausiai veikia ne detalus planas, o paprastos taisyklės. Susikuriate kelis saugius pasirinkimus, kuriuos galite rasti beveik visur ir laikotės aiškios struktūros.",
      },
      {
        id: 90,
        label: "Ar verta stebėti gliukozę, jei neturiu diabeto?",
        description:
          "Dažnai verta, jei norite suprasti, kaip konkretus maistas veikia jūsų energiją, alkį ir koncentraciją, arba jei yra polinkis į gliukozės svyravimus, antsvorį ar metabolines problemas. Stebėjimas padeda pamatyti individualią organizmo reakciją ir sutvarkyti mitybos struktūrą taip, kad diena būtų stabilesnė.",
      },
    ],
  },
];
